import * as React from 'react';
import Tabs, { TabElement } from '../Tabs/Tabs';
import { default as SearchForm } from '../SearchForm';
import Checkin from './Checkin/Checkin';
import Booking from './Booking/Booking';
import { Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme';
import { MOBILE_MIN_WIDTH } from '../utils';
import { useMediaQuery } from 'react-responsive';

export interface Tab {
	title: string;
	value: string;
	content?: React.ReactElement;
	action?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}

interface Props {
	customTabs?: Tab[];
}

const defaultTabs: Tab[] = [
	{ title: 'Search', value: 'search', content: <SearchForm /> },
	{ title: 'My booking', value: 'booking', content: <Booking /> },
	{ title: 'Checkin', value: 'checkin', content: <Checkin /> }
];

const Forms: React.FC<Props> = ({ customTabs }) => {
	const [activeTab, setActiveTab] = React.useState(0);

	const theme = useTheme('Forms').Forms;
	const { t } = useTranslation('Forms');

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const items: Tab[] = customTabs ?? defaultTabs;

	const tabs: TabElement[] = items.map((tab, index) => ({
		header: t(tab.title),
		value: index
	}));

	const onChange = (index: number): void => {
		const tab = items[index];

		if (tab.action?.href) {
			const { href, target } = tab.action;

			if (target === '_blank') {
				window.open(href, '_blank');

				return;
			}

			window.location.href = href;

			return;
		}

		setActiveTab(index);
	};

	return (
		<div>
			<Tabs
				tabs={tabs}
				onChange={onChange}
				selected={activeTab}
				className={theme.tabs}
				tabHeaderClassName={theme.tabLabel}
				selectedTabClassName={theme.tabSelected}
				indicatorClassName={theme.indicator}
				rootTabsClassName={theme.tabs__container}
				variant={isMobile ? 'scrollable' : 'standard'}
			/>

			{items.map((tab, index) =>
				!tab.action && index === activeTab ? (
					<Fade in={index === activeTab} key={tab.value}>
						<div className={theme.container}>{tab.content}</div>
					</Fade>
				) : null
			)}
		</div>
	);
};

export default Forms;
